import { render, staticRenderFns } from "./sections.vue?vue&type=template&id=027b9ecf&scoped=true&"
import script from "./sections.vue?vue&type=script&lang=js&"
export * from "./sections.vue?vue&type=script&lang=js&"
import style0 from "./sections.vue?vue&type=style&index=0&id=027b9ecf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027b9ecf",
  null
  
)

export default component.exports